import React from "react";

import FilterCompany from "./FilterCompany";
import SearchCompany from "./SearchCompany";
import { SearchFilterCompanyContainer } from "./styles";
import { SearchFilterCompanyProps } from "../types";

const SearchFilterCompany = ({
  setFilterOptions,
  onChangeInput,
  filterOptions,
  searchInput,
}: SearchFilterCompanyProps) => {
  return (
    <SearchFilterCompanyContainer>
      <SearchCompany onChangeInput={onChangeInput} searchInputValue={searchInput} />
      <FilterCompany filterOptions={filterOptions} setFilterOptions={setFilterOptions} />
    </SearchFilterCompanyContainer>
  );
};

export default SearchFilterCompany;
